import React from "react";
import chunk from "lodash/chunk";
import { DomParser } from "../utils/dom-parser";
import { renderDate } from "../utils/text-display";
import { WidgetBox, Action } from "../components";

const YourTranscript = ({ title = "Your Transcript" }) => {
    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "table[summary='Training Content'] > tbody > tr > td"
        );
        const columns = domParser.columns;
        return chunk(columns, 3)
            .map(row => {
                const [td1, td2, td3] = row;
                return {
                    title: domParser.text(td1),
                    dueDate: domParser.dateSpan(td2),
                    actions: domParser.multiAnchor(td3)
                };
            })
            .sort((a, b) => a.dueDate - b.dueDate);
    };

    const data = parseDataFromDOM();

    let titleLink = null;
    let titleLinkEl = document.querySelector(
        "div[data-tag='pnlMyTraining'] a.titleLink"
    );

    if (titleLinkEl) {
        titleLink = titleLinkEl.getAttribute("href");
    }

    return (
        <WidgetBox title={title} horizontal titleLink={titleLink}>
            <div className="your-transcript">
                {chunk(data, 2).map((col, col1) => (
                    <div key={col1} className="your-transcript__box">
                        {col.map((i, index) => (
                            <div key={index}>
                                <p className="your-transcript__box-title">
                                    {i.title}
                                </p>
                                <div className="your-transcript__secondary-content">
                                    <span className="your-transcript__secondary-content-date">
                                        {renderDate(
                                            i.dueDate,
                                            "Due date: ",
                                            null,
                                            "No due date"
                                        )}
                                    </span>
                                    <div className="your-transcript__actions">
                                        {i.actions.map((a) => (
                                            <Action key={a.actionId} {...a} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </WidgetBox>
    );
};

export default YourTranscript;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/your-transcript.js